import { subDays } from 'date-fns';
import { getDateKey } from './date';
import type { Habit } from '../types/habit';

export function isCompletedOn(habit: Habit, dateKey: string): boolean {
  return habit.completions.includes(dateKey);
}

/**
 * Current streak of consecutive completed days. If today hasn't been
 * marked yet, counting starts from yesterday so a streak doesn't drop
 * to zero the moment a new day begins.
 */
export function getStreak(habit: Habit): number {
  let cursor = new Date();
  if (!habit.completions.includes(getDateKey(cursor))) {
    cursor = subDays(cursor, 1);
  }

  let streak = 0;
  while (habit.completions.includes(getDateKey(cursor))) {
    streak += 1;
    cursor = subDays(cursor, 1);
  }
  return streak;
}
